module.exports = __webpack_public_path__ + "static/img/zhushui2.2b023933.png";